import { btcUsdPerUnitOnUtcDayNearest, ensureBtcUsdDailyLoaded } from './btcUsdDaily';

/**
 * Approximate ETH/USD from bundled BTC/USD × fixed ratio (order-of-magnitude; ratio drifts over years).
 * For strict filing, replace with a dedicated ETH/USD daily series (same CSV shape as `btc-usd-max.csv`).
 */
const ETH_FROM_BTC_RATIO = 0.055;

export function ensureEthUsdDailyLoaded(): void {
  ensureBtcUsdDailyLoaded();
}

/** USD per 1 ETH at UTC calendar day — proxy from BTC daily until a dedicated `eth-usd-max.csv` is bundled. */
export function ethUsdPerUnitOnUtcDayNearest(date: Date): number | null {
  const btc = btcUsdPerUnitOnUtcDayNearest(date);
  if (btc == null) return null;
  return btc * ETH_FROM_BTC_RATIO;
}
